import React from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { RefreshCw, Search } from 'lucide-react';

interface RandomCompaniesSearchProps {
  input: string;
  isLoading: boolean;
  onInputChange: (value: string) => void;
  onKeyDown: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  onSearch: () => void;
}

export const RandomCompaniesSearch: React.FC<RandomCompaniesSearchProps> = ({
  input,
  isLoading,
  onInputChange,
  onKeyDown,
  onSearch
}) => {
  return (
    <div className="flex gap-2">
      <Input
        placeholder="Enter industry keywords, a company name, or a company web site"
        value={input}
        onChange={(e) => onInputChange(e.target.value)}
        onKeyDown={onKeyDown}
        className="bg-slate-700 border-0 text-white placeholder:text-slate-400 text-xl"
      />
      <Button 
        onClick={onSearch}
        disabled={isLoading || !input.trim()}
        className="bg-gradient-to-r from-indigo-600 to-purple-600 hover:from-indigo-700 hover:to-purple-700 text-white border-0"
      >
        {isLoading ? (
          <RefreshCw className="w-4 h-4 animate-spin" />
        ) : (
          <Search className="w-4 h-4" />
        )}
      </Button>
    </div>
  );
}; 